<div class="field-display">
  <span class="field-value">
    <span *ngIf="showFlag && countryFlag" class="country-flag">{{ countryFlag }}</span>
    <span>{{ countryName }}</span>
  </span>
  <button type="button" mat-icon-button
      class="field-copy-button"
      matTooltip="Copy"
      [cdkCopyToClipboard]="countryName"
      (cdkCopyToClipboardCopied)="onCopyToClipboard.emit('Field value was copied to clipboard.')"
      (click)="$event.stopPropagation()">
      <mat-icon>content_copy</mat-icon>
  </button>
</div>
